<template>
  <v-dialog
    v-model="modelValue"
    max-width="600"
  >
    <v-card>
      <v-card-title
        class="d-flex align-center justify-space-between"
        style="font-weight: 600; font-size: 20px"
      >
        <span>{{ t('mftp.studyDescription') }}</span>
        <v-btn
          class="mr-n2"
          data-testid="close"
          density="compact"
          icon="close"
          variant="text"
          @click="modelValue = false"
        />
      </v-card-title>
      <v-card-text>
        <div
          v-if="isLoading"
          class="text-center"
        >
          <v-progress-circular
            color="primary"
            indeterminate
          />
        </div>
        <div v-else-if="mftpTags">
          <div class="tag-item">
            <strong class="shark-700">{{ t('mftp.studyDate') }}</strong
            >:
            <span class="tag-value">{{ mftpTags.studyDate ?? t('mftp.unknown') }}</span>
          </div>
          <div class="tag-item">
            <strong class="shark-700">{{ t('mftp.imageCount') }}</strong
            >:
            <span class="tag-value">{{ mftpTags.imageCount ?? t('mftp.unknown') }}</span>
          </div>
          <div class="tag-item">
            <strong class="shark-700">{{ t('mftp.seriesDescription') }}</strong
            >:
            <span class="tag-value">{{ mftpTags.seriesDescription ?? t('mftp.unknown') }}</span>
          </div>
          <div class="tag-item">
            <strong class="shark-700">{{ t('mftp.seriesNumber') }}</strong
            >:
            <span class="tag-value">{{ mftpTags.seriesNumber ?? t('mftp.unknown') }}</span>
          </div>
          <div class="tag-item">
            <strong class="shark-700">{{ t('mftp.instanceId') }}</strong
            >:
            <span class="tag-value">{{ mftpTags.instanceId ?? t('mftp.unknown') }}</span>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { useMftpTags } from '../composables/useMftpTags';
import { toRefs, watch } from 'vue';
import { useI18n } from 'vue-i18n';

interface Props {
  collectionId: string;
  tenantRegion?: string | null;
}

const { t } = useI18n();

const props = defineProps<Props>();
const { collectionId, tenantRegion } = toRefs(props);

const modelValue = defineModel<boolean>({ default: false });

const { state: mftpTags, isLoading, execute } = useMftpTags(collectionId, tenantRegion);

watch(
  modelValue,
  async (value) => {
    if (value) {
      await execute();
    }
  },
  { immediate: true },
);
</script>

<style scoped lang="scss">
.tag-item {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
}

.tag-value {
  font-weight: 300;
  color: grey;
}
</style>
